import { type Toast } from 'react-hot-toast'

export const createToastContentId = (toast: Toast) => `toast-content-${toast.id}`
